module.exports = __webpack_public_path__ + "img/logo.e0b49901.png";